/**
 * Procedure Categories and Procedures for DM in Hepatology students
 * Extracted with strict evidence from official NMC PDF (Page 4, 5, 10: "The student should be able to perform independently")
 */
export const HEPATOLOGY_PROCEDURES = {
  "Diagnostic & Therapeutic Gastrointestinal Endoscopy": [
    "Upper GI Endoscopy & Endoscopic Biopsies",
    "Procto-Sigmoidoscopy & Colonoscopy with Polypectomy",
    "Endoscopic Variceal Band Ligation & Endoscopic Sclerotherapy",
    "Endoscopic Variceal Glue Injection & Argon Plasma Coagulation (APC)",
    "Endoscopic Stricture Dilatation & Endoscopic Stent Placement",
    "Endoscopic Retrograde Cholangiopancreatography (ERCP) & Endosonography (EUS)",
  ],
  "Hepatobiliary, Biopsy & Vascular Intervention Procedures": [
    "Percutaneous Liver Biopsy & Transjugular Liver Biopsy (TJLB)",
    "Abdominal Paracentesis (Diagnostic & Therapeutic)",
    "Subclavian & Transjugular Central Venous Catheterization",
    "Invasive Hemodynamic Studies & Hepatic Venous Pressure Gradient (HVPG)",
    "Abdominal & Hepatobiliary Ultrasonography & Doppler Studies",
  ],
};

export const HEPATOLOGY_CATEGORIES = Object.keys(HEPATOLOGY_PROCEDURES);

export const isDMInHepatologyDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (d.includes("hepatology") || d.includes("liver")) && !d.includes("pediatric") && !d.includes("paediatric");
};
